module.exports = __webpack_public_path__ + "static/media/thumbnail-juneli-raat.20da5dcc.png";